
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { joinParams } from '@/utils/index'
export default defineComponent({
    name: 'User',
    setup () {
        const { proxy } = getCurrentInstance() as any
        const router = useRouter()
        const route = useRoute()

        const state = reactive({
            code:       route.query.code,   // 通过 code 获取列表
            tableData:  [],     // 账号列表
            page:       1,      // 当前页码
            limit:      50,     // 每页条数
            total:      0,      // 列表总条数

            // 获取列表数据
            getList () {
                const { code, page, limit } = state
                proxy.$http.get(`admin/user/getTemporary?${joinParams({ code, page, limit })}`).then((res:any) => {
                    const {code, data, count, msg} = res
                    if (code != 200) {
                        return proxy.$message({ type: 'error', message: msg })
                    }
                    state.tableData = data
                    state.total = count || 0
                })
            },
            // 删除
            onDel (row) {
                const { code:uCode } = state
                const { id, store_name } = row
                proxy.$confirm(`确定要删除 ${ store_name } 吗？`, '提示', {
                    type: 'warning'
                }).then(() => {
                    proxy.$http.post('/admin/user/delTemporary', { code:uCode, id }).then(res => {
                        const {code, data:resData, msg} = res
                        if (code != 200) {
                            return proxy.$message({ type: 'error', message: msg })
                        }
                        proxy.$message({ type: 'success', message: '删除成功' })
                        state.getList()
                    })
                }).catch(() => {
                    console.log('取消删除')
                })
            },
            // 保存
            onSave () {
                const { code:uCode } = state
                proxy.$http.post('/admin/user/sendAdminUser', { code:uCode }).then(res => {
                    const {code, data:resData, msg} = res
                    if (code != 200) {
                        return proxy.$message({ type: 'error', message: msg })
                    }
                    proxy.$message({ type: 'success', message: '保存成功' })
                    router.go(-1)
                })
            },
            // 点击页码重新获取数据
            onCurrentChange (val:number) {
                state.page = val
                state.getList()
            },
            // 表格 index 连续
            tableIndex: (index) => {
                const { page, limit } = state
                return (page - 1) * limit + index + 1
            }
        })
        // 将回显数据中错误行标红
        const rowClassName = ({row}) => {
            return row.check ? 'error-row' : ''
        }
        state.getList()
        return { ...toRefs(state), rowClassName }
    }
})
